// TODO: ПОчему это не лежит в сервисе metadata?
export const METADATA = {
  product: {
    title: '{продукт}: полезная информация о том, как сравнить и выбрать на выгодных условиях',
    description: '',
    heading: 'Путеводители {продукт.предложный}',
    headingTemplate: 'Путеводители {продукт.предложный}',
  },
  other: {
    title: '{категория} - Статьи и полезные материалы',
    description: '{категория}. Статьи, полезные материалы, советы.',
    heading: '{категория}',
    headingTemplate: '{категория}',
  },
  enciklopediya: {
    title: 'Энциклопедия',
    heading: 'Энциклопедия',
    description: '',
    headingTemplate: 'Энциклопедия',
  },
  category: {
    title: '{категория} - Статьи и полезные материалы',
    description: '{категория}. Статьи, полезные материалы, советы.',
    heading: '{категория}',
    headingTemplate: '{категория}',
  },
  subCategory: {
    title: '{подкатегория} - Статьи и полезные материалы',
    description: '{подкатегория}. Статьи, полезные материалы, советы.',
    heading: '{подкатегория}',
    headingTemplate: '{подкатегория}',
  },
};
